import React from 'react';
import {
  string, object, oneOf, arrayOf, func,
} from 'prop-types';
import classnames from 'classnames';
import { withI18n } from '@active/react-utils/i18n/LocaleContext';

const TextHr = ({
  i18n, className, id, values,
}) => {
  const text = i18n(id, values);
  return (
    <hr className={classnames([ 'hr-text', className ])} data-content={text} />
  );
};

TextHr.propTypes = {
  i18n: func.isRequired,
  className: string,
  id: string.isRequired,
  values: oneOf([ object, arrayOf(string) ]),
  defaultMsg: string,
};

TextHr.defaultProps = {
  className: '',
  values: null,
};

export default withI18n(TextHr);
